import { differenceInCalendarDays, format } from 'date-fns';

const VIEW_CONFIGS = {
  year: {
    dayWidth: 2.5,
    monthsRange: 18,
  },
  quarter: {
    dayWidth: 5,
    monthsRange: 12,
  },
  month: {
    dayWidth: 15,
    monthsRange: 8,
  },
  week: {
    dayWidth: 30,
    monthsRange: 6,
  },
};

export default function setup(view = 'week', { startDate, endDate } = {}) {
  const today = new Date();
  // full width on small screens, total width - sidebar width - content container's right padding on large screens
  const containerWidth = window.innerWidth < 1024 ? window.innerWidth : window.innerWidth - 256 - 8;
  const startX = containerWidth / 2;
  const viewConfig = VIEW_CONFIGS[view];
  startDate = startDate
    ? new Date(startDate)
    : new Date(today.getFullYear(), today.getMonth() - viewConfig.monthsRange, 1);
  endDate = endDate
    ? new Date(endDate)
    : new Date(today.getFullYear(), today.getMonth() + viewConfig.monthsRange, 1);

  const monthItems = [];
  for (let i = 0; i < viewConfig.monthsRange * 2; i++) {
    const date = new Date(startDate.getFullYear(), startDate.getMonth() + i, 1);
    monthItems.push({
      key: date.getTime(),
      label: format(date, 'MMM'),
      translateX: startX - differenceInCalendarDays(today, date) * viewConfig.dayWidth,
    });
  }

  const dayItems = [];
  const weekends = [];
  let mondayToAdd = new Date(startDate.getTime());
  while (mondayToAdd.getDay() !== 1) {
    mondayToAdd = new Date(
      mondayToAdd.getFullYear(),
      mondayToAdd.getMonth(),
      mondayToAdd.getDate() - 1,
    );
  }

  while (mondayToAdd < endDate) {
    const translateX = startX - differenceInCalendarDays(today, mondayToAdd) * viewConfig.dayWidth;
    dayItems.push({
      key: mondayToAdd.getTime(),
      label: mondayToAdd.getDate(),
      translateX,
    });
    mondayToAdd = new Date(
      mondayToAdd.getFullYear(),
      mondayToAdd.getMonth(),
      mondayToAdd.getDate() + 7,
    );
    weekends.push({
      left: translateX + 5 * viewConfig.dayWidth,
      width: viewConfig.dayWidth * 2,
    });
  }

  const config = {
    view,
    today,
    containerWidth,
    startX,
    startDate,
    endDate,
    monthItems,
    dayItems,
    scrollMin: -(dayItems.at(-1).translateX - containerWidth) - 16,
    scrollMax: -dayItems.at(0).translateX + 16,
    dayWidth: viewConfig.dayWidth,
    weekends,
  };

  return config;
}
